import useSWR from 'swr';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

export interface Category {
  id: string;
  name: string;
  type: string;
  color?: string;
}

export const useCategories = (type: string = 'item') => {
  const { token, currentBusiness, isCookieMode, API_BASE_URL } = useAuth();

  const fetcher = ([url, businessId, type]: [string, string, string]) => {
    const headers: any = {
    };
    
    // Only add Authorization header if not in cookie mode
    if (!isCookieMode && token) {
      headers.Authorization = `Bearer ${token}`;
    }
    
    return axios.get(`${API_BASE_URL}${url}`, {
      headers,
      withCredentials: isCookieMode, // This sends cookies with the request
    }).then(res => res.data);
  };

  const { data: categories = [], error, isLoading, mutate } = useSWR(
    currentBusiness ? ['/categories', currentBusiness.id, type] : null,
    fetcher
  );

  return { categories, error, isLoading, mutate };
}; 